import type { AccordionCardListCard } from '@/app/_components/shared/accordion-card-list/accordion-card-list.types';
import { AccordionCardListCtas } from './accordion-card-list-ctas';
import { AccordionCardListImage } from './accordion-card-list-image';

export function AccordionCardListItem({
  card,
  moduleId,
  trackingPrefix,
}: {
  card: AccordionCardListCard;
  moduleId: string;
  trackingPrefix?: string;
}) {
  return (
    <article id={`${moduleId}-${card.id}`} className="flex flex-col gap-3">
      <AccordionCardListImage card={card} />

      <div className="space-y-1">
        {card.persons.length > 0 && (
          <p className="text-sm font-bold">
            {card.persons.map((person, index) => (
              <span key={person.name}>
                {index > 0 && ', '}
                {person.url ? (
                  <a
                    href={person.url}
                    className="text-primary underline hover:no-underline"
                    data-track-id={
                      trackingPrefix
                        ? `${trackingPrefix}-person-${index + 1}`
                        : undefined
                    }
                  >
                    {person.name}
                  </a>
                ) : (
                  person.name
                )}
              </span>
            ))}
          </p>
        )}

        {card.location && (
          <p className="line-clamp-1 text-sm text-muted-foreground">
            {card.location}
          </p>
        )}
      </div>

      <AccordionCardListCtas ctas={card.ctas} trackingPrefix={trackingPrefix} />
    </article>
  );
}
